export class CompanyProperties {
	readonly properties: Map<string, boolean>;
	constructor(values: Record<string, IPayrollDataValue>) {
		this.properties = new Map(Object.entries(values).map(([key, val]) => [key, val.boolValue]));
	}
}

export interface IPayrollDataValue {
	boolValue: boolean;
}

export function hasCompanyPropertiesInSystem(
	properties: Map<string, CompanyProperties>,
	system: string,
	feature: string,
) {
	const thisSystem = properties.get(system);
	const featuresOnSystem = thisSystem?.properties;
	const featureFlag = featuresOnSystem?.get(feature);
	return featureFlag === true;
}
